<template>
    <div class="card mb-4">
        <div class="card-header">
            <h2>Donatieniveau aanpassen</h2>
        </div>
        <div class="card-body">
            <p>Het gehele jaar kan je je donatieniveau aanpassen. De wijziging wordt jaarlijks op 1 januari verwerkt.</p>
            <a :href="route" class="btn btn-primary">Aanpassen</a>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        route: String,
    },
}
</script>



// WEBPACK FOOTER //
// resources/assets/components/UitkeringAanpassen.vue